import { Command, HttpMethod } from "~/extensions/api";
export class DeleteAdminInformationCommand extends Command {
    constructor(informationNo) {
        super(HttpMethod.Post, "information/admin/delete");
        this.informationNo = informationNo;
    }
    informationNo = null;
}
